import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import editorFormMixin from 'next/javascripts/mixins/editor-form-mixin';
import editorDraftMixin from 'next/javascripts/mixins/editor-draft-mixin';
import 'next/stylesheets/components/reports/answer-form.scss';

Component('tr-reports-answer-form', {
  mixins: [eventListenerMixin, editorFormMixin, editorDraftMixin],

  properties: {
    viewerSettingVisible: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.editor = this.querySelector('tr-editor');

    this.listenTo(
      this.querySelector('.cancel-button'),
      'click',
      this.handleFormCancel.bind(this),
    );

    const viewerSettingLink = this.querySelector('.link-viewer-setting');
    if (viewerSettingLink) {
      this.listenTo(viewerSettingLink, 'click', () => {
        this.viewerSettingVisible = true;
      });
    }

    $(this).on('ajax:beforeSend', 'form', this.beforeFormSubmit.bind(this));
  },

  disconnected() {
    this.stopListening();
  },

  insertTodos(todosContent) {
    if (!this.editor) return;
    this.editor.setData(this.editor.getData() + todosContent);
    this.editor.focus();
  },

  beforeFormSubmit(event, xhr, settings) {
    const attachIds = this.editor.getAttachIds();
    // eslint-disable-next-line no-param-reassign
    settings.data += `&attach_guids=${attachIds.join(',')}&is_html=1`;
  },

  handleFormCancel() {
    const cancel = this.namespacedTrigger('cancel');
    if (cancel) this.cancel();
  },

  cancel() {
    this.remove();
  },
});
